import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';
import { getDefaultHeaders } from 'core-lib/utils/network';
import { RatingAndReviewData } from '../../types';

const formatRating = (obj, count) => {
  if (!count) return [];
  const arr = Object.keys(obj)
    ?.sort((a, b) => Number(b) - Number(a))
    ?.map((item) => ({
      rating: +item,
      percent: Math.round((obj[item] * 100) / count),
    }));
  return arr;
};

const serializer = (res) => {
  const obj: RatingAndReviewData = {
    page: Number(res?.page) || 1,
    limit: Number(res?.limit),
    count: Number(res?.count),
    ratingsData: {
      count: Number(res?.ratings?.total_count),
      avgRating: res?.ratings?.average_rating,
      data: formatRating(res?.ratings?.data, Number(res?.ratings?.total_count)),
    },
    reviewsData: res?.reviews.map((item) => ({
      rating: item?.rating,
      title: item?.review_title || 'Good Product',
      description: item?.review_description || '',
      media: item?.image_url,
      postedOn: item?.created_at || null,
      userMeta: {
        name:
          item?.name ||
          `User@${
            item?.user_meta_data?.phone_number
              ? item?.user_meta_data?.phone_number?.slice(0, 5)
              : Math.ceil(Math.random() * 100000)
          }`,
        email: item?.email,
        phoneNumber: item?.phone_number,
        image:
          item?.user_meta_data?.profile_pic ||
          'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__340.png',
      },
    })),
  };
  return obj;
};

const getUserReviews = async (productId: number, page: number, limit = 5) => {
  const endPoint = `${apiConfig(
    'magento'
  )}/default/V1/custom/reviews/customer/${productId}?pageNo=${page}&limit=${limit}`;

  const { response, error }: any = await getMethod({
    endPoint,
    headers: getDefaultHeaders({ deviceId: true }),
  });

  if (response?.data) {
    return { response: serializer(response.data) };
  } else {
    return { error };
  }
};

export default getUserReviews;
